module.exports = __webpack_public_path__ + "static/media/transfer-PROCESSING.5a71f959.svg";